import { createContext } from "react";

const AuthContext = createContext({} as any);

export default AuthContext;